import type { HealthQualityResponseDto } from '@/services/types';

import type { HealthQuality } from './types';

export function mapHealthQualityToDomain(dto: HealthQualityResponseDto): HealthQuality {
    return {
        day: dto.day ?? null,
        downgradeRate: dto.downgradeRate ?? null,
    };
}
